/** Sub-query key used by DataTable for pinned comments. */
export const PINNED_COMMENTS_SUB_KEY = "__pinnedComments";

/** PostgREST select for the pinned-comments sub-query. */
export const PINNED_COMMENTS_SELECT =
  "id, commentable_type, commentable_id, content, tag, is_pinned, is_deleted, created_at, updated_at, created_by_employee_id, created_by_employee:created_by_employee_id(id, full_name, thumbnail_photo_url)";

/** PostgREST select for the full comment thread (drawer). Includes resolved audit. */
export const COMMENTS_FULL_SELECT =
  "id, commentable_type, commentable_id, content, tag, is_pinned, is_deleted, created_at, updated_at, created_by_employee_id, created_by_employee:created_by_employee_id(id, full_name, thumbnail_photo_url), resolved_at, resolved_by_employee_id, resolved_by_employee:resolved_by_employee_id(id, full_name, thumbnail_photo_url)";
